import type { MantineColorsTuple } from '@mantine/core'

export const bluedotPrimaryColors: MantineColorsTuple = [
  '#f7eaff', // 0
  '#e7d1ff', // 1
  '#cba0fc', // 2
  '#ad6bf8', // 3
  '#953ff5', // 4
  '#8523f4', // 5
  '#7d14f4', // 6
  '#6b08da', // 7
  '#5f04c3', // 8
  '#5100ac', // 9
]

// Design-specific green colors - replaces default Mantine green
export const designGreenColors: MantineColorsTuple = [
  '#f5fbf6', // 0 - lightest green tint
  '#e8f5ea', // 1 - very light green
  '#d1ecb5', // 2 - light green
  '#b4e682', // 3 - medium light green
  '#8bd04f', // 4 - medium green
  '#45a04a', // 5 - design green (main)
  '#3d8f42', // 6 - slightly darker green
  '#357d3a', // 7 - medium dark green
  '#2d6c32', // 8 - dark green
  '#255a2a', // 9 - darkest green
]

// Design-specific gray colors - replaces default Mantine gray
export const designGrayColors: MantineColorsTuple = [
  '#F3F3F7', // 0 - design gray (main)
  '#ededf0', // 1 - no orders card background
  '#dee2e6', // 2
  '#ced4da', // 3
  '#adb5bd', // 4
  '#6c757d', // 5
  '#5a6268', // 6 - dimmed (darker than 5)
  '#495057', // 7 - medium dark
  '#303840', // 8 - design black (main)
  '#1a1e23', // 9 - darkest
]

// Design-specific red colors - replaces default Mantine red
export const designRedColors: MantineColorsTuple = [
  '#fff5f5', // 0 - lightest red tint
  '#ffe3e3', // 1 - very light red
  '#ffc9c9', // 2 - light red
  '#ffa8a8', // 3 - medium light red
  '#ff8787', // 4 - medium red
  '#E01A22', // 5 - design red (main)
  '#c91e27', // 6 - slightly darker red
  '#b11e2c', // 7 - medium dark red
  '#9a1d31', // 8 - dark red
  '#831c36', // 9 - darkest red
]
